/* eslint-disable max-len,react/jsx-tag-spacing */
import React from 'react';
import classNames from 'classnames';
import css from './Icon.module.scss';

interface Props {
  type: string;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
  secondaryColor?: string;
  onClick?: (event: React.MouseEvent) => void;
}

const Icon = ({ type, className, width, height, color, secondaryColor, onClick, ...iconProps }: Props) => {
  let icon = null;
  const svgProps = {
    width,
    height,
    viewBox: `0 0 ${width || 38} ${height || 38}`,
    xmlns: 'http://www.w3.org/2000/svg',
  };

  switch (type) {
    case 'redArrowDown': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21.115 12.538">
          <path
            id="down_red_arrow"
            data-name="down red_arrow"
            d="M16.191,19.235l7.562-7.568a1.423,1.423,0,0,1,2.019,0,1.441,1.441,0,0,1,0,2.025L17.2,22.265a1.427,1.427,0,0,1-1.971.042L6.6,13.7a1.429,1.429,0,0,1,2.019-2.025Z"
            transform="translate(-5.688 -10.746)"
            fill="#ed1c24"
            stroke="#fff"
            strokeWidth="1"
          />
        </svg>
      );
      break;
    }

    case 'plusIcon': {
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          fill="currentColor"
          className="bi bi-plus"
          viewBox="0 0 16 16"
        >
          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg>
      );
      break;
    }
    case 'redArrowUp': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21.115 12.538">
          <path
            id="up_red_arrow"
            d="M16.191,14.694l7.562,7.568a1.423,1.423,0,0,0,2.019,0,1.441,1.441,0,0,0,0-2.025L17.2,11.663a1.427,1.427,0,0,0-1.971-.042L6.6,20.231a1.429,1.429,0,0,0,2.019,2.025Z"
            transform="translate(-5.688 -10.644)"
            fill="#ed1c24"
            stroke="#fff"
            strokeWidth="1"
          />
        </svg>
      );
      break;
    }

    case 'friends': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 23 23">
          <g id="frinds" transform="translate(-920 -721)">
            <path
              id="icon_frind"
              d="M11.5,0A11.5,11.5,0,1,1,0,11.5,11.5,11.5,0,0,1,11.5,0Z"
              transform="translate(920 721)"
              fill="#db181f"
            />
            <path
              id="Icon_metro-user"
              data-name="Icon metro-user"
              d="M11.9,14.151v-.763a4.133,4.133,0,0,0,1.851-3.439c0-2.3,0-4.164-2.776-4.164S8.2,7.649,8.2,9.948a4.133,4.133,0,0,0,1.851,3.439v.763c-3.139.257-5.552,1.8-5.552,3.664H17.454c0-1.865-2.413-3.407-5.552-3.664Z"
              transform="translate(920.501 720.186)"
              fill="#fff"
            />
          </g>
        </svg>
      );
      break;
    }

    case 'whatsapp': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21.662 21.662">
          <g id="whatsapp" transform="translate(1 1)">
            <g id="wt" transform="translate(-14248.999 -6971)" fill="none">
              <path
                d="M14249,6980.829a9.831,9.831,0,1,1,9.829,9.833A9.83,9.83,0,0,1,14249,6980.829Zm4.154-.163a5.874,5.874,0,0,0,.787,2.942l-.835,3.047,3.119-.819a5.9,5.9,0,0,0,2.811.718h0a5.884,5.884,0,1,0-5.885-5.889Zm5.882,4.894a4.892,4.892,0,0,1-2.488-.681l-.177-.106-1.854.485.5-1.8-.117-.185a4.89,4.89,0,1,1,4.143,2.291Zm-2.472-7.423a1.639,1.639,0,0,0-.515,1.224,2.87,2.87,0,0,0,.6,1.522,6.6,6.6,0,0,0,2.512,2.217,8.352,8.352,0,0,0,.837.31,1.987,1.987,0,0,0,.928.058,1.51,1.51,0,0,0,.991-.7,1.223,1.223,0,0,0,.085-.7c-.036-.061-.133-.1-.28-.171s-.871-.43-1-.479-.234-.075-.33.073-.381.478-.464.577-.174.11-.321.035a4.007,4.007,0,0,1-1.182-.729,4.445,4.445,0,0,1-.819-1.017c-.083-.148,0-.221.066-.3a4.321,4.321,0,0,0,.367-.5.275.275,0,0,0-.013-.258c-.035-.072-.33-.794-.454-1.089-.1-.253-.214-.253-.3-.253h-.031c-.086,0-.184,0-.282,0A.537.537,0,0,0,14256.563,6978.137Z"
                stroke="none"
              />
              <path
                d="M 14258.828125 6970.99951171875 C 14253.400390625 6970.99951171875 14248.9990234375 6975.4013671875 14248.9990234375 6980.8291015625 C 14248.9990234375 6986.2578125 14253.400390625 6990.66162109375 14258.828125 6990.66162109375 C 14264.2587890625 6990.66162109375 14268.6611328125 6986.2578125 14268.6611328125 6980.8291015625 C 14268.6611328125 6975.4013671875 14264.2587890625 6970.99951171875 14258.828125 6970.99951171875 M 14259.0380859375 6986.55517578125 L 14259.03515625 6986.55517578125 C 14258.0517578125 6986.552734375 14257.08203125 6986.30615234375 14256.224609375 6985.83740234375 L 14253.10546875 6986.65625 L 14253.9404296875 6983.60888671875 C 14253.4248046875 6982.716796875 14253.1533203125 6981.70361328125 14253.1533203125 6980.66650390625 C 14253.15625 6977.42529296875 14255.794921875 6974.787109375 14259.0380859375 6974.787109375 C 14260.611328125 6974.787109375 14262.08984375 6975.39892578125 14263.2001953125 6976.51123046875 C 14264.3125 6977.623046875 14264.9208984375 6979.10107421875 14264.9208984375 6980.6728515625 C 14264.919921875 6983.91455078125 14262.2822265625 6986.55517578125 14259.0380859375 6986.55517578125 M 14259.0400390625 6975.77978515625 C 14256.3427734375 6975.77978515625 14254.1484375 6977.97314453125 14254.1474609375 6980.66845703125 C 14254.1474609375 6981.59130859375 14254.4072265625 6982.49169921875 14254.8955078125 6983.26953125 L 14255.0126953125 6983.45458984375 L 14254.5166015625 6985.2578125 L 14256.3701171875 6984.77294921875 L 14256.546875 6984.87939453125 C 14257.2978515625 6985.32373046875 14258.1591796875 6985.56005859375 14259.03515625 6985.56005859375 L 14259.0380859375 6985.56005859375 C 14261.732421875 6985.56005859375 14263.92578125 6983.36669921875 14263.927734375 6980.67138671875 C 14263.927734375 6979.36474609375 14263.419921875 6978.13671875 14262.4970703125 6977.21435546875 C 14261.5751953125 6976.2890625 14260.345703125 6975.77978515625 14259.0400390625 6975.77978515625 M 14259.76171875 6982.15478515625 C 14259.8232421875 6982.15478515625 14259.8720703125 6982.12646484375 14259.921875 6982.0712890625 C 14260.0048828125 6981.97265625 14260.287109375 6981.642578125 14260.3857421875 6981.49462890625 C 14260.48046875 6981.34716796875 14260.5810546875 6981.37158203125 14260.7158203125 6981.421875 C 14260.849609375 6981.47021484375 14261.5751953125 6981.8251953125 14261.720703125 6981.900390625 C 14261.8681640625 6981.97265625 14261.96484375 6982.01025390625 14262.0009765625 6982.0712890625 C 14262.0380859375 6982.13330078125 14262.0380859375 6982.42578125 14261.916015625 6982.76953125 C 14261.7939453125 6983.11279296875 14261.20703125 6983.42578125 14260.9248046875 6983.4677734375 C 14260.671875 6983.5078125 14260.3505859375 6983.5224609375 14259.9970703125 6983.41015625 C 14259.783203125 6983.34228515625 14259.5107421875 6983.251953125 14259.16015625 6983.10009765625 C 14257.6865234375 6982.4638671875 14256.724609375 6980.9794921875 14256.6484375 6980.8828125 C 14256.5751953125 6980.783203125 14256.048828125 6980.08544921875 14256.048828125 6979.36083984375 C 14256.048828125 6978.638671875 14256.4287109375 6978.28125 14256.5634765625 6978.13671875 C 14256.697265625 6977.98828125 14256.8583984375 6977.95166015625 14256.9541015625 6977.95166015625 C 14257.052734375 6977.95166015625 14257.150390625 6977.95166015625 14257.236328125 6977.9560546875 C 14257.2451171875 6977.9560546875 14257.2568359375 6977.9560546875 14257.267578125 6977.9560546875 C 14257.3525390625 6977.9560546875 14257.4619140625 6977.9560546875 14257.56640625 6978.208984375 C 14257.6904296875 6978.50390625 14257.9853515625 6979.22607421875 14258.0205078125 6979.29833984375 C 14258.0576171875 6979.3740234375 14258.0810546875 6979.4599609375 14258.033203125 6979.556640625 C 14257.9853515625 6979.6552734375 14257.8193359375 6979.8671875 14257.666015625 6980.06103515625 C 14257.599609375 6980.14013671875 14257.5166015625 6980.212890625 14257.599609375 6980.36083984375 C 14257.6865234375 6980.5078125 14257.98046875 6980.98828125 14258.4189453125 6981.3779296875 C 14258.98046875 6981.87744140625 14259.453125 6982.03369140625 14259.6005859375 6982.1064453125 C 14259.6640625 6982.138671875 14259.716796875 6982.15478515625 14259.76171875 6982.15478515625 M 14258.828125 6969.99951171875 C 14264.8017578125 6969.99951171875 14269.6611328125 6974.857421875 14269.6611328125 6980.8291015625 C 14269.6611328125 6986.80224609375 14264.8017578125 6991.66162109375 14258.828125 6991.66162109375 C 14252.857421875 6991.66162109375 14247.9990234375 6986.80224609375 14247.9990234375 6980.8291015625 C 14247.9990234375 6974.857421875 14252.857421875 6969.99951171875 14258.828125 6969.99951171875 Z"
                stroke="none"
                fill="#ed1c24"
              />
            </g>
          </g>
        </svg>
      );
      break;
    }
    case 'envelope': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21.89 21.89">
          <g id="mas" transform="translate(0.5 0.5)">
            <path
              id="Path_1276"
              data-name="Path 1276"
              d="M10.445,0A10.445,10.445,0,1,1,0,10.445,10.445,10.445,0,0,1,10.445,0Z"
              fill="none"
              stroke="#ed1c24"
              strokeWidth="1"
            />
            <path
              id="Icon_material-mail-outline"
              data-name="Icon material-mail-outline"
              d="M13.735,6H4.193A1.144,1.144,0,0,0,3.006,7.092L3,13.642a1.149,1.149,0,0,0,1.193,1.092h9.542a1.149,1.149,0,0,0,1.193-1.092V7.092A1.149,1.149,0,0,0,13.735,6Zm0,7.642H4.193V8.183l4.771,2.729,4.771-2.729ZM8.964,9.821,4.193,7.092h9.542Z"
              transform="translate(2)"
              fill="#ed1c24"
            />
          </g>
        </svg>
      );
      break;
    }
    case 'facebook':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26.346 26.236">
          <g id="_002-facebook-circular-logo" data-name="002-facebook-circular-logo" transform="translate(0 -0.055)">
            <path
              id="Path"
              d="M13.173,0a13.166,13.166,0,0,0-2.2,26.148V15.921H7.8v-3.68h3.178V9.527c0-3.149,1.923-4.865,4.732-4.865a26.225,26.225,0,0,1,2.837.144V8.1H16.6c-1.527,0-1.822.726-1.822,1.791v2.349H18.42l-.475,3.68H14.776V26.236A13.167,13.167,0,0,0,13.173,0Z"
              transform="translate(0 0.055)"
              fill={secondaryColor}
            />
          </g>
        </svg>
      );
      break;

    case 'instagram':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26.4 26.4">
          <g id="Group_53" data-name="Group 53" transform="translate(-61.6 -222)">
            <g id="_006-instagram" fill={secondaryColor} data-name="006-instagram" transform="translate(61.6 222)">
              <path
                id="Path"
                d="M5.053,2.527A2.527,2.527,0,1,1,2.527,0,2.527,2.527,0,0,1,5.053,2.527Z"
                transform="translate(10.673 10.673)"
              />
              <path
                id="Shape"
                d="M3.151,12.384a4.217,4.217,0,0,1-1.408-.261,2.345,2.345,0,0,1-.871-.567,2.348,2.348,0,0,1-.567-.872A4.205,4.205,0,0,1,.044,9.277C.008,8.478,0,8.238,0,6.214S.008,3.95.044,3.151A4.217,4.217,0,0,1,.305,1.743,2.356,2.356,0,0,1,.872.872,2.348,2.348,0,0,1,1.744.305,4.205,4.205,0,0,1,3.151.044C3.95.008,4.19,0,6.214,0S8.478.008,9.277.044a4.205,4.205,0,0,1,1.407.261,2.348,2.348,0,0,1,.872.567,2.352,2.352,0,0,1,.567.871,4.217,4.217,0,0,1,.261,1.408c.036.8.044,1.039.044,3.064s-.008,2.264-.044,3.063a4.205,4.205,0,0,1-.261,1.407,2.513,2.513,0,0,1-1.439,1.439,4.205,4.205,0,0,1-1.407.261c-.8.036-1.04.044-3.064.044S3.95,12.42,3.151,12.384Z"
                transform="translate(6.986 6.986)"
              />
              <path id="Shape-2" data-name="Shape" d="M0,13.2A13.2,13.2,0,1,1,13.2,26.4,13.2,13.2,0,0,1,0,13.2Z" />
            </g>
            <path
              id="Icon_awesome-instagram"
              data-name="Icon awesome-instagram"
              d="M7.01,5.654a3.6,3.6,0,1,0,3.6,3.6A3.59,3.59,0,0,0,7.01,5.654Zm0,5.933A2.338,2.338,0,1,1,9.348,9.25,2.342,2.342,0,0,1,7.01,11.587Zm4.581-6.08a.839.839,0,1,1-.839-.839A.837.837,0,0,1,11.591,5.507Zm2.381.851A4.15,4.15,0,0,0,12.84,3.42,4.178,4.178,0,0,0,9.9,2.287c-1.158-.066-4.628-.066-5.786,0a4.172,4.172,0,0,0-2.938,1.13A4.164,4.164,0,0,0,.044,6.355c-.066,1.158-.066,4.628,0,5.786A4.15,4.15,0,0,0,1.177,15.08a4.183,4.183,0,0,0,2.938,1.133c1.158.066,4.628.066,5.786,0A4.15,4.15,0,0,0,12.84,15.08a4.178,4.178,0,0,0,1.133-2.938c.066-1.158.066-4.625,0-5.783Zm-1.5,7.025a2.367,2.367,0,0,1-1.333,1.333A15.456,15.456,0,0,1,7.01,15a15.576,15.576,0,0,1-4.134-.282,2.367,2.367,0,0,1-1.333-1.333A15.456,15.456,0,0,1,1.261,9.25a15.576,15.576,0,0,1,.282-4.134A2.367,2.367,0,0,1,2.876,3.783,15.456,15.456,0,0,1,7.01,3.5a15.576,15.576,0,0,1,4.134.282,2.367,2.367,0,0,1,1.333,1.333,15.456,15.456,0,0,1,.282,4.134A15.447,15.447,0,0,1,12.477,13.384Z"
              transform="translate(67.791 225.922)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;

    case 'tikTok':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26">
          <g id="Group_54" data-name="Group 54" transform="translate(-107 -222)">
            <circle
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="13"
              cy="13"
              r="13"
              fill={secondaryColor}
              transform="translate(107 222)"
            />
            <path
              id="Icon_simple-tiktok"
              data-name="Icon simple-tiktok"
              d="M8.912.012C9.695,0,10.471.006,11.248,0a3.722,3.722,0,0,0,1.046,2.492,4.214,4.214,0,0,0,2.533,1.07V5.969a6.4,6.4,0,0,1-2.51-.58,7.382,7.382,0,0,1-.968-.556c-.006,1.745.006,3.489-.012,5.228a4.564,4.564,0,0,1-.807,2.354A4.452,4.452,0,0,1,7,14.334a4.357,4.357,0,0,1-2.438-.615,4.506,4.506,0,0,1-2.181-3.412c-.012-.3-.018-.6-.006-.89A4.5,4.5,0,0,1,7.591,5.425c.012.884-.024,1.769-.024,2.653A2.05,2.05,0,0,0,4.95,9.345a2.37,2.37,0,0,0-.084.962,2.034,2.034,0,0,0,2.091,1.715,2.007,2.007,0,0,0,1.655-.962,1.379,1.379,0,0,0,.245-.633c.06-1.07.036-2.133.042-3.2.006-2.408-.006-4.81.012-7.212Z"
              transform="translate(111.999 228.004)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;
    case 'blackDownArrow': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13.748 7.86">
          <path
            id="black_down_arrow"
            d="M13.064,16.737l5.2-5.2a.978.978,0,0,1,1.388,0,.991.991,0,0,1,0,1.392l-5.89,5.894a.981.981,0,0,1-1.355.029L6.474,12.931a.983.983,0,1,1,1.388-1.392Z"
            transform="translate(-6.188 -11.246)"
          />
        </svg>
      );
      break;
    }

    case 'upStageArrow': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 57 57">
          <g id="up_page" transform="translate(-1655 -1628)">
            <circle
              id="Ellipse_9"
              data-name="Ellipse 9"
              cx="28.5"
              cy="28.5"
              r="28.5"
              transform="translate(1655 1628)"
              fill="#fff"
            />
            <path
              id="Icon_ionic-ios-arrow-down"
              data-name="Icon ionic-ios-arrow-down"
              d="M16.191,14.694l7.562,7.568a1.423,1.423,0,0,0,2.019,0,1.441,1.441,0,0,0,0-2.025L17.2,11.663a1.427,1.427,0,0,0-1.971-.042L6.6,20.231a1.429,1.429,0,0,0,2.019,2.025Z"
              transform="translate(1667.313 1638.318)"
              fill="#ed1c24"
            />
          </g>
        </svg>
      );
      break;
    }
    case 'search':
      icon = (
        <svg {...svgProps} width={width} height={height} viewBox="0 0 27.9 27.9">
          <g id="search" transform="translate(0 0)">
            <path
              id="Shape"
              d="M26.667,27.9h0l-9.455-9.455a10.486,10.486,0,1,1,1.233-1.233L27.9,26.667,26.668,27.9ZM10.463,1.744a8.719,8.719,0,1,0,8.719,8.718A8.728,8.728,0,0,0,10.463,1.744Z"
              transform="translate(0 0)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;

    case 'locationMarker': {
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="11.1" height="14.8" viewBox="0 0 11.1 14.8">
          <path
            id="Icon_awesome-map-marker-alt"
            data-name="Icon awesome-map-marker-alt"
            d="M4.98,14.5C.78,8.413,0,7.788,0,5.55a5.55,5.55,0,0,1,11.1,0c0,2.238-.78,2.863-4.98,8.951a.694.694,0,0,1-1.141,0Zm.57-6.639A2.313,2.313,0,1,0,3.238,5.55,2.313,2.313,0,0,0,5.55,7.863Z"
            fill="#615858"
          />
        </svg>
      );
      break;
    }
    case 'star':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 30">
          <g id="star" transform="translate(-1535 -600)">
            <circle
              id="star-2"
              data-name="star"
              cx="15"
              cy="15"
              r="15"
              transform="translate(1535 600)"
              fill="#ed1c24"
            />
            <path
              id="Icon_awesome-star"
              data-name="Icon awesome-star"
              d="M9.836.625,7.54,5.279,2.4,6.028a1.125,1.125,0,0,0-.622,1.919L5.5,11.568l-.879,5.115A1.124,1.124,0,0,0,6.25,17.867l4.594-2.415,4.594,2.415a1.125,1.125,0,0,0,1.631-1.185l-.879-5.115,3.716-3.621a1.125,1.125,0,0,0-.622-1.919l-5.136-.749L11.853.625A1.126,1.126,0,0,0,9.836.625Z"
              transform="translate(1539.155 605.001)"
              fill="#fff"
            />
          </g>
        </svg>
      );
      break;
    case 'closePopUp':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="34.041" height="34.041" viewBox="0 0 34.041 34.041">
          <path
            d="M1.028-19.4h11.02v2.082H1.028v10.97h-2.082v-10.968h-10.968V-19.4h10.968v-11.02h2.082z"
            transform="rotate(45 -34.219 19.85)"
          />
        </svg>
      );
      break;
    case 'deleteFile':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="15.097" height="15.097" viewBox="0 0 15.097 15.097">
          <path
            id="Path_1311"
            data-name="Path 1311"
            d="M4.283,10.437V6.25H0V4.156H4.283V0H6.63V4.156h4.283V6.25H6.63v4.188Z"
            transform="translate(7.38) rotate(45)"
          />
        </svg>
      );
      break;
    case 'smile':
      icon = (
        <svg id="smile" xmlns="http://www.w3.org/2000/svg" width="28.38" height="28.38" viewBox="0 0 28.38 28.38">
          <path
            id="Path_1302"
            data-name="Path 1302"
            d="M15.315,1.125a14.19,14.19,0,1,0,14.19,14.19A14.19,14.19,0,0,0,15.315,1.125Zm8.7,22.886A12.254,12.254,0,1,1,26.647,20.1a12.254,12.254,0,0,1-2.636,3.909Z"
            transform="translate(-1.125 -1.125)"
          />
          <path
            id="Path_1303"
            data-name="Path 1303"
            d="M10.688,14.063h2.365v2.365H10.688Z"
            transform="translate(-2.647 -3.183)"
          />
          <path
            id="Path_1304"
            data-name="Path 1304"
            d="M22.5,14.063h2.365v2.365H22.5Z"
            transform="translate(-4.526 -3.183)"
          />
          <path
            id="Path_1305"
            data-name="Path 1305"
            d="M21.545,21.564a4.943,4.943,0,0,1-4.611,3.122h-.509a4.943,4.943,0,0,1-4.611-3.121l-.076-.189H9.7l.357.891a6.858,6.858,0,0,0,6.368,4.312h.509A6.858,6.858,0,0,0,23.3,22.267l.357-.892H21.621Z"
            transform="translate(-2.489 -4.347)"
          />
        </svg>
      );
      break;
    case 'plus':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="10.913" height="10.437" viewBox="0 0 10.913 10.437">
          <path id="plus" d="M4.283,10.437V6.25H0V4.156H4.283V0H6.63V4.156h4.283V6.25H6.63v4.188Z" />
        </svg>
      );
      break;
    case 'tnuca':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="408.549" height="199.387" viewBox="0 0 408.549 199.387">
          <defs>
            <clipPath id="clipPath">
              <path
                id="Path_3039"
                data-name="Path 3039"
                d="M0,44c2.1,1.976,14.461,4.565,14.461,4.565S44.108,18.724,51.535,8.444a416.079,416.079,0,0,0,34.72,42.479C121.865,61.171,185.178,65.193,187,65.309v-.079c-.986-2.063-20.046-42-19.607-48.105C167.844,10.851,49.23,0,49.23,0S20.905,30.347,0,44"
                fill="none"
              />
            </clipPath>
            <linearGradient id="linear-gradient" x1="0.5" x2="0.396" y2="1.371" gradientUnits="objectBoundingBox">
              <stop offset="0" stopColor="#f30002" />
              <stop offset="1" stopColor="#d40004" />
            </linearGradient>
            <clipPath id="clipPath-2">
              <path
                id="Path_3040"
                data-name="Path 3040"
                d="M0,0V0C7.911,14.966,36.657,51.141,117.626,63.216c-4.025-9.894-20.092-42.941-19.742-48.4C98.241,9.215,21.881,2.441,0,0Z"
                transform="translate(0 0)"
                fill="none"
              />
            </clipPath>
            <linearGradient
              id="linear-gradient-2"
              x1="-0.435"
              y1="1.227"
              x2="-0.431"
              y2="1.227"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stopColor="red" />
              <stop offset="0.03" stopColor="red" stopOpacity="0.835" />
              <stop offset="1" stopColor="#ff8000" stopOpacity="0.463" />
            </linearGradient>
          </defs>
          <g id="Tnuca_LOGO" data-name="Tnuca LOGO" transform="translate(-9629.442 -2284.039)">
            <path
              id="Path_2015"
              data-name="Path 2015"
              d="M402.182,182.625l-152.81,2.661L2.685,189.206l5.262-24.464,396.468,9.141Z"
              transform="translate(9633.576 2294.219)"
              fill="#66b72d"
            />
            <g id="Group_3447" data-name="Group 3447" transform="translate(9636.259 2299.366)">
              <path
                id="טיול_משפחתי"
                data-name="טיול משפחתי"
                d="M276.974,150.2V136.7a1.567,1.567,0,0,1,1.659-1.659h1.438c19.9,0,29.082-15.7,29.082-28.419v-.222a2.612,2.612,0,0,0-2.764-2.764H278.522c-3.539,0-6.193-2.322-6.193-5.971V76.328a1.657,1.657,0,0,1,1.658-1.769h15.37a1.746,1.746,0,0,1,1.769,1.769V86.723h31.405a5.456,5.456,0,0,1,5.75,5.75v15.26c0,13.048-8.957,44.232-47.107,44.232h-2.544A1.657,1.657,0,0,1,276.974,150.2Zm68.56,0v-42.9c0-2.654-1.107-3.538-3.539-3.538h-5.2a1.657,1.657,0,0,1-1.658-1.769V88.492a1.657,1.657,0,0,1,1.658-1.769h14.6c8.4,0,13.38,4.533,13.38,12.937V150.2A1.746,1.746,0,0,1,363,151.964H347.192A1.657,1.657,0,0,1,345.534,150.2Zm36.426-21.452V107.29c0-2.654-1-3.538-3.429-3.538h-6.966a1.657,1.657,0,0,1-1.659-1.769V88.492a1.657,1.657,0,0,1,1.659-1.769H387.93c8.4,0,12.938,4.533,12.938,12.937v29.082a1.747,1.747,0,0,1-1.769,1.769h-15.37A1.746,1.746,0,0,1,381.959,128.743Zm24.88-5.75v-34.5a1.657,1.657,0,0,1,1.659-1.769H424.31a1.746,1.746,0,0,1,1.769,1.769v30.077c0,10.284,5.418,15.923,14.6,15.923s14.707-5.639,14.707-15.923v-7.851c0-4.866-1.658-7.741-7.188-7.741a8.068,8.068,0,0,0-3.1.442c-1.326.554-1.879.111-1.879-1.106V89.708a2.2,2.2,0,0,1,1.216-1.99c2.653-1.438,6.524-1.88,9.841-1.88,12.164,0,20.347,6.855,20.347,17.692v19.463c0,18.245-14.928,29.856-33.948,29.856C421.767,152.848,406.839,141.46,406.839,122.993Z"
                transform="translate(-77.918 -74.559)"
                fill="#0064b3"
              />
              <path
                id="טיול_משפחתי-2"
                data-name="טיול משפחתי"
                d="M12.054,124.413V102.961c0-2.654-.995-3.538-3.428-3.538H1.66A1.658,1.658,0,0,1,0,97.653V84.163A1.657,1.657,0,0,1,1.66,82.394H18.026c8.4,0,12.937,4.533,12.937,12.938v29.082a1.746,1.746,0,0,1-1.769,1.769H13.824A1.747,1.747,0,0,1,12.054,124.413Zm71.622,21.452V113.687c0-9.731-1.327-14.375-12.053-14.375H66.757v30.631c0,14.154-7.741,18.467-19.683,18.467-4.755,0-10.947-.553-10.947-4.092V133.591c0-1.437.774-2.543,2.211-2.432a30.723,30.723,0,0,0,4.313.331c2.544,0,4.866-1.438,4.866-5.2V99.312h-7.63a1.4,1.4,0,0,1-1.549-1.548V83.942a1.4,1.4,0,0,1,1.549-1.548H79.806c14.155,0,23.112,7.63,23.112,21.784v41.688a1.747,1.747,0,0,1-1.769,1.769H85.335A1.657,1.657,0,0,1,83.676,145.866Zm27.424,0V83.942a1.4,1.4,0,0,1,1.549-1.548h35.5c14.154,0,23.111,7.63,23.111,21.784v41.688a1.747,1.747,0,0,1-1.769,1.769H153.674a1.658,1.658,0,0,1-1.659-1.769V113.687c0-9.731-1.326-14.375-12.052-14.375h-9.621v46.554a1.747,1.747,0,0,1-1.769,1.769H112.759A1.657,1.657,0,0,1,111.1,145.866Zm66.592-8.957c-.773-.774-.331-1.88.332-2.654l8.293-9.51c.884-.995,2.211-.995,3.538,0a23.925,23.925,0,0,0,15.812,5.529c11.39,0,18.356-5.971,18.356-15.7,0-7.85-4.312-15.26-14.265-15.26H197.708v3.318a3.894,3.894,0,0,0,3.981,4.091,1.713,1.713,0,0,1,1.769,1.879v13.049c0,1.106-.442,1.658-1.769,1.658-15.813,0-22.558-8.846-22.558-20.568v-18.8a1.4,1.4,0,0,1,1.548-1.548h33.727c17.25,0,28.861,11.832,28.861,31.846,0,23.111-15.149,34.722-36.048,34.722C193.395,148.962,183.332,143.986,177.692,136.909Zm72.674-21.231V84.163a1.657,1.657,0,0,1,1.658-1.769h15.812a1.747,1.747,0,0,1,1.77,1.769v19.02h2.432c4.534,0,5.64-2.654,5.64-7.962V83.942a1.4,1.4,0,0,1,1.548-1.548h15.592a1.4,1.4,0,0,1,1.549,1.548V98.981c0,13.269-9.51,20.457-20.79,20.457h-5.2c1.88,7.741,6.967,10.726,16.366,10.726,12.274,0,17.029-5.086,17.029-19.13V84.163a1.746,1.746,0,0,1,1.769-1.769h15.813a1.657,1.657,0,0,1,1.658,1.769v31.515c0,22.336-15.37,32.841-36.27,32.841S250.367,138.015,250.367,115.678Zm80.878,30.188v-5.529c0-17.25,3.207-31.846,11.279-40.914h-9.841a1.746,1.746,0,0,1-1.769-1.769V84.163a1.746,1.746,0,0,1,1.769-1.769h37.928c13.27,0,26.1,6.413,26.1,23.331V141q0,6.635-6.635,6.635H364.75a1.657,1.657,0,0,1-1.658-1.769v-13.49a1.657,1.657,0,0,1,1.658-1.769h10.5a2.09,2.09,0,0,0,2.212-2.212V107.716c0-5.75-4.424-8.4-8.736-8.4-9.841,0-18.134,13.933-18.134,44.343v2.211a1.747,1.747,0,0,1-1.769,1.769H332.9A1.657,1.657,0,0,1,331.245,145.866Z"
                transform="translate(-0.001 5.845)"
                fill="#0064b3"
              />
            </g>
            <path
              id="Path_2017"
              data-name="Path 2017"
              d="M9553.363,2060.368Z"
              transform="translate(79.062 285.294)"
              fill="#66b72d"
            />
            <path
              id="Path_2016"
              data-name="Path 2016"
              d="M426.083,37.78q0,3.657-3.492,6.958a40.052,40.052,0,0,1-6.145,4.939,2.727,2.727,0,0,1-1.654.5,3.678,3.678,0,0,1-2.206-.7,2,2,0,0,1-.972-1.627,2.3,2.3,0,0,1,1.129-1.8q6.406-4.8,8.35-7.338a2.394,2.394,0,0,0,.525-1.353,1.461,1.461,0,0,0-.538-1.152,2.812,2.812,0,0,0-1.825-.463q-4.568,0-13.864,4.441a4.292,4.292,0,0,1-1.838.38,4.538,4.538,0,0,1-2.468-.677,1.945,1.945,0,0,1-1.077-1.65,2.547,2.547,0,0,1,1.13-1.9q2.152-1.805,8.061-3.372a35.661,35.661,0,0,1,8.271-1.353q4.2,0,6.407,1.721a5.4,5.4,0,0,1,2.205,4.453Zm-17.541,7.789a9.179,9.179,0,0,1-3.755,4.155,3.687,3.687,0,0,1-1.943.641q-1.708,0-1.707-1.781a3.174,3.174,0,0,1,.368-1.424,13.455,13.455,0,0,0,1.233-3.206q.6-2.373,3.44-2.374,2.7,0,2.7,2.564a3.175,3.175,0,0,1-.342,1.425Zm44.658-6.72a9.742,9.742,0,0,1-1.811,5.343,17.987,17.987,0,0,1-2.915,3.372,6.59,6.59,0,0,1-4.017,1.923,4.747,4.747,0,0,1-2.573-.724,2.018,2.018,0,0,1-1.156-1.65q0-.926,1.235-1.639a14.5,14.5,0,0,0,5.593-5.414,4.224,4.224,0,0,0,.6-1.947q0-1.639-2.154-1.734h-.918a27.257,27.257,0,0,0-8.061,1.686,4.334,4.334,0,0,1-.6,2.921,33.38,33.38,0,0,1-5.514,7.884,3.652,3.652,0,0,1-2.547,1.164q-1.708,0-1.707-1.449a2.876,2.876,0,0,1,.472-1.472,58.86,58.86,0,0,0,3.65-7.527q-2.26-.689-2.258-2.541a2.122,2.122,0,0,1,1.365-1.876,28.345,28.345,0,0,1,6.249-1.923,33.917,33.917,0,0,1,6.8-.95q7.222,0,9.375,3.3a6.086,6.086,0,0,1,.892,3.253Zm25.318-.736q0,4.038-3.545,7.694a21.179,21.179,0,0,1-6.105,4.286,15.4,15.4,0,0,1-6.551,1.745,7.209,7.209,0,0,1-4.832-1.7,5.2,5.2,0,0,1-2-4.1,5.574,5.574,0,0,1,2.6-4.607,8.948,8.948,0,0,1,5.488-1.757,7.38,7.38,0,0,1,1.13.095,7.189,7.189,0,0,1,3.006,1.366q1.668,1.175,1.667,1.935a.687.687,0,0,1-.446.688,1.252,1.252,0,0,1-.893-.047,4.182,4.182,0,0,0-2.1-.427,10.921,10.921,0,0,0-4.7,1.686,2.649,2.649,0,0,0-1.339,2.042q0,.974,1.47.974,2.52,0,6.933-3.3,4.2-3.111,5.33-5.438A3.666,3.666,0,0,0,474,37.685a1.67,1.67,0,0,0-.5-1.4,2.6,2.6,0,0,0-1.917-.594q-3.439,0-11.291,3.751a4.291,4.291,0,0,1-1.838.38,4.539,4.539,0,0,1-2.468-.677,1.976,1.976,0,0,1-1.077-1.7,2.651,2.651,0,0,1,1.129-1.9,17.261,17.261,0,0,1,6.827-2.968,29.783,29.783,0,0,1,6.985-.974q6.512,0,8.35,4.583a5.542,5.542,0,0,1,.315,1.924Zm19.694-3.253q0,3.657-5.856,7.2a25.642,25.642,0,0,1-7.746,2.825,8.1,8.1,0,0,0-.158,1.757q0,1.9,1.445,1.9,1.522,0,4.346-2.042t3.9-2.042a1.577,1.577,0,0,1,1.391.878,2.219,2.219,0,0,1,.42,1.354,2.01,2.01,0,0,1-.473,1.4,12.15,12.15,0,0,1-4.267,2.945,12.615,12.615,0,0,1-5.081,1.235q-7.274,0-7.851-5.913-.472-4.535,4.622-9.961t10.109-5.426a5.91,5.91,0,0,1,3.965,1.235,3.377,3.377,0,0,1,1.234,2.66Zm-6.486-.38a1.745,1.745,0,0,0-1.024.332,13.541,13.541,0,0,0-3.217,3.158,16.969,16.969,0,0,0-2.429,4.179,15.328,15.328,0,0,0,4.411-2.9,11.045,11.045,0,0,0,2.941-3.8,1.278,1.278,0,0,0,.052-.333q0-.641-.735-.641ZM519.1,39.632q-3.939,7.433-4.91,8.952a3.3,3.3,0,0,1-2.994,1.259,2.851,2.851,0,0,1-2.7-1.71,77.019,77.019,0,0,1-2.888-7.195q-2.389,4.44-6.565,11.516-.866,1.353-1.759,1.354-1.418,0-1.418-1.924a4.552,4.552,0,0,1,.446-1.9q3.256-7.1,6.486-14.675,1.391-3.324,3.6-3.324,2,0,3.072,3.229.657,2.042,2.573,7.48,3.991-8.6,5.7-13.274a3.6,3.6,0,0,1,3.781-2.374q2.415,0,2.416,2.327a4.414,4.414,0,0,1-.368,1.709q-.657,1.4-4.464,8.549ZM538.882,48.3Q532.4,60.149,531.32,61.954a2.312,2.312,0,0,1-1.943,1.353,1.708,1.708,0,0,1-1.353-.629,2.315,2.315,0,0,1-.538-1.556,3.472,3.472,0,0,1,.342-1.472q5.934-12.444,12.394-26.382.866-2.35,4.306-2.35a1.743,1.743,0,0,1,2,1.947,5.358,5.358,0,0,1-.512,2.1q-.512,1.176-7.129,13.333Zm26.843-8.667q-3.938,7.433-4.91,8.952a3.3,3.3,0,0,1-2.993,1.259,2.851,2.851,0,0,1-2.705-1.71,77.019,77.019,0,0,1-2.888-7.195q-2.39,4.44-6.564,11.516-.867,1.353-1.759,1.354-1.419,0-1.419-1.924a4.539,4.539,0,0,1,.447-1.9q3.255-7.1,6.486-14.675,1.392-3.324,3.6-3.324,2,0,3.072,3.229.656,2.042,2.574,7.48,3.99-8.6,5.7-13.274a3.6,3.6,0,0,1,3.781-2.374q2.415,0,2.416,2.327a4.413,4.413,0,0,1-.368,1.709q-.657,1.4-4.464,8.549Zm25.81,2.47a5.491,5.491,0,0,1-1.943,4.144,13.226,13.226,0,0,1-5.75,2.767,25.458,25.458,0,0,1-6.46.831,14.6,14.6,0,0,1-7.8-1.9,2.418,2.418,0,0,1-1.392-2.089,1.785,1.785,0,0,1,.538-1.318,1.394,1.394,0,0,1,1.221-.44,12.288,12.288,0,0,1,1.628.594,11.1,11.1,0,0,0,4.307.688,16.28,16.28,0,0,0,5.645-.926q2.889-1.021,3.6-2.826a2.186,2.186,0,0,0,.209-.973,3.068,3.068,0,0,0-1.365-2.541q-1.365-1.021-2.232-.665-1.838.784-3.6,1.543a11.954,11.954,0,0,1-4.044.879,4.9,4.9,0,0,1-2.547-.654,1.919,1.919,0,0,1-1.1-1.674,2.606,2.606,0,0,1,1.077-1.948q2.574-2.136,8.324-2.185a13.9,13.9,0,0,0,4.255-5.295q1.338-2.541,2.625-2.3,1.024.142,1.024,1.947a5.23,5.23,0,0,1-.1,1.021,15.044,15.044,0,0,1-2.573,5.7,12.4,12.4,0,0,1,5.54,4.511,5.783,5.783,0,0,1,.919,3.111Z"
              transform="translate(9233.992 2327.021)"
              fill="#e70003"
            />
            <g
              id="Group_3509"
              data-name="Group 3509"
              transform="matrix(0.996, -0.087, 0.087, 0.996, 9629.442, 2300.336)"
            >
              <path
                id="Path_3043"
                data-name="Path 3043"
                d="M7.33,44.7,83.617,41.94,45.022,0,0,42.342Z"
                transform="translate(5.221 3.841)"
                fill="#b50e11"
              />
              <g id="Group_3504" data-name="Group 3504" transform="translate(0 0)">
                <g id="Group_3505" data-name="Group 3505" transform="translate(0)">
                  <g id="Group_3504-2" data-name="Group 3504" transform="translate(0 0)" clipPath="url(#clipPath)">
                    <path
                      id="Path_3041"
                      data-name="Path 3041"
                      d="M0,0,101.785,3.357l5.766,197.871L5.766,197.871Z"
                      transform="translate(-16.784 61.856) rotate(-76.708)"
                      fill="url(#linear-gradient)"
                    />
                  </g>
                </g>
                <g id="Group_3507" data-name="Group 3507" transform="translate(69.282 2.098)">
                  <g id="Group_3506" data-name="Group 3506" transform="translate(0 0)" clipPath="url(#clipPath-2)">
                    <path
                      id="Path_3042"
                      data-name="Path 3042"
                      d="M.614.872,172.136,0l-.614,121.125L0,122Z"
                      transform="matrix(0.802, -0.597, 0.597, 0.802, -63.272, 46.47)"
                      opacity="0.75"
                      fill="url(#linear-gradient-2)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
      break;

    default:
      break;
  }

  return (
    <i className={classNames(css.icon, className)} {...iconProps} onClick={onClick}>
      {icon}
    </i>
  );
};

Icon.defaultProps = {
  className: '',
  width: 38.945,
  height: 38.948,
  color: '#111',
  secondaryColor: '#000',
  onClick: () => null,
};

export default Icon;
